module.exports = __webpack_public_path__ + "static/glenecho-71d65174847fde8234061d247ead8200.png";